export enum CopilotTrackerPropertyType {
	WITH_OPEN_BUBBLE = 'with_open_bubble',
	WITH_CLOSE_BUBBLE = 'with_close_bubble',
	ON_LANDING_PAGE = 'on_landing_page'
}
